{
  "name": "cms-pwa-simple-museum",
  "version": "1.0.3",
  "description": "YOUCA PWA based on the Elsa PWA",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "serve-dev": "ng serve --configuration development",
    "serve-prod": "ng serve --configuration production",
    "client-gen-keycloak": "openapi-generator-cli generate -g typescript-angular -o src/api/keycloak -i ./swagger/swagger_keycloak.json  --additional-properties=ngVersion=22.1.3",
    "client-gen-rest": "openapi-generator-cli generate -g typescript-angular -o src/api/rest -i ./swagger/swagger_rest.json --additional-properties=ngVersion=22.1.3",
    "client-gen-sync": "openapi-generator-cli generate -g typescript-angular -o src/api/sync -i ./swagger/swagger_sync.json --additional-properties=ngVersion=22.1.3",
    "client-gen-organization": "openapi-generator-cli generate -g typescript-angular -o src/api/organization -i ./swagger/swagger_organization.json --additional-properties=ngVersion=22.1.3",
    "generate-models": "npm run client-gen-rest && npm run client-gen-keycloak && npm run client-gen-sync && npm run client-gen-organization",
    "prebuild": "npm run generate-models",
    "build": "ng build --base-href / --deploy-url /",
    "build-dev": "ng build --base-href / --deploy-url / --configuration development",
    "build-stage": "ng build --base-href / --deploy-url / --configuration development",
    "build-prod": "ng build --base-href / --deploy-url / --configuration production",
    "build-local": "ng build --base-href / --deploy-url / --configuration production --outputPath=dist",
    "run-dev-android": "ng build --configuration development && npx cap sync && npx cap run android",
    "run-dev-ios": "ng build --configuration development && npx cap sync && npx cap run ios",
    "run-prod-android": "ng build --configuration production && npx cap sync && npx cap run android",
    "build-native-dev": "npm run generate-models && ng build --configuration development && npx cap sync",
    "build-native-prod": "npm run generate-models && ng build --configuration production && npx cap sync",
    "serve-pwa": "http-server -p 8080 -c-1 dist",
    "test": "ng test",
    "eslint": "eslint",
    "lint": "eslint. "
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~22.1.3",
    "@angular/cdk": "^22.1.3",
    "@angular/common": "~22.1.3",
    "@angular/compiler": "~22.1.3",
    "@angular/core": "~22.1.3",
    "@angular/forms": "~22.1.3",
    "@angular/google-maps": "^22.1.3",
    "@angular/localize": "~22.1.3",
    "@angular/material": "^22.1.3",
    "@angular/platform-browser": "~22.1.3",
    "@angular/platform-browser-dynamic": "~22.1.3",
    "@angular/router": "~22.1.3",
    "@angular/service-worker": "~22.1.3",
    "@capacitor/android": "^8.0.2",
    "@capacitor/app": "^8.0.0",
    "@capacitor/core": "^8.0.2",
    "@capacitor/ios": "^8.0.2",
    "@capacitor/share": "^8.0.0",
    "@ebarooni/capacitor-calendar": "^8.0.0",
    "@ngrx/effects": "^22.0.0-rc.0",
    "@ngrx/entity": "^22.0.0-rc.0",
    "@ngrx/router-store": "^22.0.0-rc.0",
    "@ngrx/schematics": "^22.0.0-rc.0",
    "@ngrx/store": "^22.0.0-rc.0",
    "@ngrx/store-devtools": "^22.0.0-rc.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "jwt-decode": "~4.0.0",
    "ngx-matomo-client": "10.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^8.3.2"
  },
  "devDependencies": {
    "@angular/build": "^22.1.5",
    "@angular/cli": "^22.1.5",
    "@angular/compiler-cli": "~22.1.3",
    "@angular/language-service": "~22.1.3",
    "@capacitor/cli": "^8.0.2",
    "@openapitools/openapi-generator-cli": "^2.28.1",
    "@types/jasmine": "~6.0.0",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^25.2.0",
    "@typescript-eslint/eslint-plugin": "^8.67.0",
    "@typescript-eslint/parser": "^8.67.0",
    "angular-eslint": "22.1.0",
    "eslint": "^10.8.1",
    "http-server": "^14.1.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^6.0.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "ts-node": "~10.9.2",
    "typescript-eslint": "8.67.0"
  }
}